export interface SiteCategory {
  slug: string;
  name: string;
  subtitle: string;
  desc: string;
  icon: string;
  image: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  content: string;
}

export const SITE_URL = "https://vg1k62.cn";

export const siteInfo = {
  name: "吃瓜片场",
  slogan: "私拍吃瓜 · 花絮路透侧拍彩蛋合集站",
  tagline: "正片之外的细节，都在这里按分类排好",
  intro:
    "吃瓜片场把剧组里那些零散流出的花絮、路透、侧拍、彩蛋与候场片段，重新按类型整理成独立合集。你不用在各个时间线里翻找，只要按分类点进去，就能顺着线索看完一段完整的幕后故事。",
  email: "hello@chiguapianchang.com",
  wechat: "chiguapianchang",
  replyTime: "工作日 10:00 - 19:00 内回复",
  startYear: 2021,
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "合集大厅", to: "/collections" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export const categories: SiteCategory[] = [
  {
    slug: "huaxu",
    name: "花絮现场",
    subtitle: "NG・笑场・拍摄方法",
    desc: "记录同一条镜头背后反复拍摄的过程，包含 NG、笑场、临时改动和演员之间的临场默契，是理解成片质感最直接的一类内容。",
    icon: "ri-movie-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Classic%20wooden%20film%20clapperboard%20resting%20on%20a%20warm%20wooden%20desk%20under%20soft%20tungsten%20lighting%2C%20clean%20minimal%20background%2C%20subtle%20analog%20film%20grain%2C%20cozy%20editorial%20still%20photography%20with%20warm%20neutral%20tones&width=800&height=600&seq=chigua-cat-huaxu&orientation=landscape",
  },
  {
    slug: "lutou",
    name: "路透速览",
    subtitle: "外景・造型・天气状况",
    desc: "外景拍摄期间从片场传出的即时画面与现场状况，涵盖造型调整、连续夜戏、天气应对等，帮你把零碎路透串成完整时间线。",
    icon: "ri-camera-lens-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinema%20camera%20lens%20close%20up%20with%20warm%20golden%20lens%20flare%2C%20dark%20minimal%20background%2C%20soft%20bokeh%20light%20orbs%2C%20subtle%20analog%20film%20grain%2C%20premium%20editorial%20product%20photography%20in%20warm%20amber%20tones&width=800&height=600&seq=chigua-cat-lutou&orientation=landscape",
  },
  {
    slug: "cepai",
    name: "侧拍角度",
    subtitle: "机位・光线・第二现场",
    desc: "从监视器之外的机位看过去，记录主光以外的第二现场：走位、灯位、替身与道具调度，解释画面为什么长成最后的样子。",
    icon: "ri-focus-3-line",
    image:
      "https://readdy.ai/api/search-image?query=Single%20warm%20spotlight%20beam%20cutting%20through%20haze%20on%20an%20empty%20theater%20stage%2C%20deep%20shadow%20and%20minimal%20composition%2C%20cinematic%20analog%20film%20grain%2C%20rich%20warm%20amber%20tones%2C%20editorial%20photography&width=800&height=600&seq=chigua-cat-cepai&orientation=landscape",
  },
  {
    slug: "caidan",
    name: "彩蛋收集",
    subtitle: "伏笔・细节・隐藏呼应",
    desc: "整理画面里容易被忽略的伏笔与呼应：字幕、道具、时间标记、背景画外音，把散落的小细节集中成一份可对照的清单。",
    icon: "ri-magic-line",
    image:
      "https://readdy.ai/api/search-image?query=Folded%20storyboard%20pencil%20sketches%20and%20handwritten%20notes%20scattered%20on%20a%20warm%20wooden%20desk%2C%20soft%20daylight%20from%20a%20window%2C%20clean%20minimal%20background%2C%20editorial%20still%20life%20photography%20with%20warm%20neutral%20tones&width=800&height=600&seq=chigua-cat-caidan&orientation=landscape",
  },
  {
    slug: "houchang",
    name: "候场切片",
    subtitle: "等待・补妆・临时改词",
    desc: "灯光调试与转场之间的等待时间同样有内容：补妆、对词、临时改台词、剧组日常，这些片段拼出拍摄现场真实的节奏。",
    icon: "ri-time-line",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20backstage%20dressing%20chair%20with%20warm%20mirror%20bulbs%20and%20a%20cloth%20draped%20over%20it%2C%20moody%20warm%20lighting%2C%20minimal%20cinematic%20composition%2C%20subtle%20analog%20film%20grain%2C%20editorial%20photography&width=800&height=600&seq=chigua-cat-houchang&orientation=landscape",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "吃瓜片场主要整理哪些内容？",
    a: "我们围绕「正片之外」的素材做整理，目前分为花絮现场、路透速览、侧拍角度、彩蛋收集与候场切片五个分类，每个分类下都是同一主题的独立合集，方便你按兴趣挑选。",
  },
  {
    q: "这些合集和官方物料有什么区别？",
    a: "官方物料通常是成片与预告，我们关注的是拍摄过程中的现场记录与细节解释，例如同一条镜头拍了多少次、光线怎么调、某个道具为什么出现，更像是给成片做的一份补充说明。",
  },
  {
    q: "合集内容会持续更新吗？",
    a: "会。片场素材往往是零散出现的，我们会把新的片段补进对应分类的合集里，旧合集也会在补充内容后更新一次正文，所以建议以合集页的更新时间为准。",
  },
  {
    q: "如何在站内快速找到想看的内容？",
    a: "可以在合集大厅按分类切换，也可以在搜索框输入剧名、演员、道具或关键词过滤。合集详情页右侧还有同分类推荐，顺着看下去不容易断线索。",
  },
  {
    q: "内容里提到的称呼和细节准确吗？",
    a: "我们只依据可公开看到的画面与现场流传的物料进行描述，避免主观猜测。若同一细节存在多种说法，会在正文中并列说明，而不是只保留一种结论。",
  },
  {
    q: "我可以提供素材或者补充线索吗？",
    a: "可以。通过联系我们页面提交说明即可，写清剧名、场景和大致时间点会更有帮助。我们会在核对后决定是否整理成新的合集或补充到已有合集里。",
  },
  {
    q: "浏览这些内容需要注册账号吗？",
    a: "不需要。站内内容全部开放浏览，也没有登录门槛。我们不做用户数据沉淀，所以你不必担心留下个人信息。",
  },
  {
    q: "为什么同一个场景会被拆进不同分类？",
    a: "因为观察角度不同。同一个镜头，拍摄过程属于花絮现场，机位与光线属于侧拍角度，而画面里的隐藏呼应会归到彩蛋收集。分类是入口，不是限制。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "林知夏",
    role: "追剧五年的老观众",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20portrait%20silhouette%20of%20a%20person%20in%20soft%20amber%20light%2C%20clean%20neutral%20background%2C%20analog%20film%20grain%2C%20editorial%20style%2C%20gentle%20warm%20tones&width=200&height=200&seq=chigua-ava-01&orientation=squarish",
    content:
      "以前看路透都是刷到哪算哪，看完就忘。这里把同一部剧的片段按分类摆在一起，我第一次把整个外景拍摄的时间线看明白了。",
  },
  {
    name: "周牧",
    role: "影视剪辑爱好者",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20portrait%20silhouette%20of%20a%20young%20creator%20with%20soft%20sunlight%2C%20clean%20neutral%20background%2C%20analog%20film%20grain%2C%20editorial%20style%2C%20warm%20earthy%20tones&width=200&height=200&seq=chigua-ava-02&orientation=squarish",
    content:
      "侧拍角度那一类对我帮助最大，灯位和走位讲得很实在，不是空泛的夸。看完再去回看成片，很多画面的选择都能对应上。",
  },
  {
    name: "苏念",
    role: "影视院校在读",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20portrait%20silhouette%20of%20a%20student%20in%20soft%20window%20light%2C%20clean%20neutral%20background%2C%20analog%20film%20grain%2C%20editorial%20style%2C%20muted%20warm%20tones&width=200&height=200&seq=chigua-ava-03&orientation=squarish",
    content:
      "候场切片里那些补妆和临时改词的过程很真实，和课堂上讲的完全不一样。作为一个了解行业实际节奏的入口，挺好用的。",
  },
  {
    name: "何一舟",
    role: "内容站长年读者",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20portrait%20silhouette%20of%20a%20reader%20in%20soft%20amber%20studio%20light%2C%20clean%20neutral%20background%2C%20analog%20film%20grain%2C%20editorial%20style%2C%20soft%20warm%20tones&width=200&height=200&seq=chigua-ava-04&orientation=squarish",
    content:
      "彩蛋收集这份清单做得很细，字幕和道具的呼应都标了位置。我会一边看一边比对，比单纯刷片段有意思得多。",
  },
];

export const siteStats = [
  { value: "1280+", label: "已整理合集片段" },
  { value: "5", label: "主题分类栏目" },
  { value: "96%", label: "读者表示线索更清晰" },
  { value: "每周", label: "持续补充新素材" },
];

export const contentPrinciples = [
  {
    icon: "ri-emotion-happy-line",
    title: "只看画面说话",
    desc: "描述以可公开看到的画面为准，不做无依据的推测，也不给人物贴标签。",
  },
  {
    icon: "ri-list-check-2",
    title: "分类先行",
    desc: "任何一条新素材都先归入花絮、路透、侧拍、彩蛋或候场，避免内容堆在一起。",
  },
  {
    icon: "ri-time-line",
    title: "标注时间线",
    desc: "尽量写清拍摄的阶段与大致顺序，让零散片段能够串成一条可读的线索。",
  },
  {
    icon: "ri-shield-check-line",
    title: "保持边界",
    desc: "不传播私人行程与未授权的个人空间信息，只做拍摄相关的公开内容整理。",
  },
];